export const TASK_CONSTANTS : any = {

    sourceType: {
        EMAIL       : 'email',
        ZAPIER      : 'zapier'
    },

    role: {
        CREATOR: 1,
        ASSIGNEE: 2,
        COLLABORATOR: 3
    },


    // DEPRECATED - const.task.icon
    // icon: {
    //     task: 'gdt-task',
    //     idea: 'gdt-idea',
    //     question: 'gdt-question',
    //     bug: 'gdt-bug',
    //
    //     beer: 'gdt-beer',
    //     book: 'gdt-book',
    //     briefcase: 'gdt-briefcase',
    //     social_broadcast: 'gdt-broadcast',
    //
    //     upload: 'gdt-cloud-upload',
    //     download: 'gdt-cloud-download',
    //
    //
    //     device_mobile: "gdt-device-mobile",
    //     device_desktop: "gdt-device-desktop",
    //
    //     phone: "gdt-phone",
    //     money: "gdt-money",
    //
    //     device_video: "gdt-device-camera-video",
    //     device_camera: "gdt-device-camera",
    //     database: "gdt-database",
    //     file_binary: "gdt-file-binary",
    //     file_code: "gdt-file-code",
    //     file_contact: "gdt-file-contact",
    //     file_text: "gdt-file-text",
    //     flame: "gdt-flame",
    //     globe: "gdt-globe",
    //     gift: "gdt-gift",
    //     dev_gist: "gdt-project-dev",
    //     graph: "gdt-graph",
    //     law: "gdt-law",
    //     key: "gdt-key",
    //     link: "gdt-link",
    //     location: "gdt-location",
    //     mail: "gdt-mail",
    //     mail_read: "gdt-mail-read",
    //     mention: "gdt-mention",
    //     milestone: "gdt-milestone",
    //     study: "gdt-graduation",
    //     pulse: "gdt-pulse",
    //     social_rss: "gdt-social-rss",
    //     search: "gdt-search",
    //     squirrel: "gdt-squirrel",
    //     steps: "gdt-steps",
    //     telescope: "gdt-telescope",
    //     tools: "gdt-tools",
    //     contact: "gdt-contact",
    //     anchor: "gdt-anchor",
    //     bookmark: "gdt-bookmark",
    //     burst: "gdt-burst",
    //     first_aid: "gdt-first-aid",
    //     paint_bucket: "gdt-paint-bucket",
    //     quote: "gdt-quote",
    //     social_youtube: "gdt-social-youtube",
    //     trophy: "gdt-trophy",
    //     shield: "gdt-shield",
    //     shopping_cart: "gdt-shopping-cart",
    //     rocket: "gdt-rocket",
    //     brush: "gdt-brush",
    //     bucket: "gdt-bucket",
    //     social_twitter: "gdt-social-twitter",
    //     userSearch: "gdt-user-search",
    //     megaphone: "gdt-megaphone",
    // },

    scheduleStatus: {
        NOT_SCHEDULED: 0,
        SCHEDULED: 1,
        SOMEDAY: 2
    },

    recurrencyFrequency: {
        DAILY: 1,
        WEEKLY: 2,
        MONTHLY: 3,
        YEARLY: 4
    },

    systemType: {
        TASK: 1,
        SUBTASK: 2
    }
};